import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { FitNodeToViewEvent } from 'components/Graph/model/GraphCommandEvents';

export type FitNodeToViewCommand = FitNodeToViewEvent;

export const fitNodeToView: GraphCommandFactory<FitNodeToViewCommand> =
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.emit('fitNodeToView', command);
  };
